import { Decision } from "components/Decision";
import { Page } from "pages/Page";

const title = "You're already logged in";
const description = "You can't access this page when you're already logged in";

export const AuthBlockedPage = () => (
    <Page canonical={window.location.href} description={description} title={title}>
        <div className="container-mini">
            <Decision text={title} />
        </div>
    </Page>
);
